<template>
  <div class="user-register">
    <form class="fc-form">
      <div class="fc-form-row">
        <b> Mobile Nummer: {{userData.phone }} </b>
      </div>
      <div class="fc-form-row">
        <input v-model.tirm="userData.email" placeholder="Email*"/>
        <span v-if="$v.userData.email.$error" class="form-error">Eine gültige E-Mail-Adresse ist erforderlich</span>
      </div>
      <div class="fc-form-row">
        <input v-model.tirm="userData.firstName" placeholder="Vorname*"/>
        <span v-if="$v.userData.firstName.$error" class="form-error">Vorname ist erforderlich</span>
      </div>
      <div class="fc-form-row">
        <input v-model.tirm="userData.lastName" placeholder="Nachname*"/>
        <span v-if="$v.userData.lastName.$error" class="form-error">Nachname ist erforderlich</span>
      </div>

<!--      <div class="fc-form-row">-->
<!--        <upload-image v-model="userData.image"/>-->
<!--        <span v-if="$v.userData.image.$error" class="form-error">Foto ist erforderlich</span>-->
<!--      </div>-->
      <!--<div class="fc-form-row">-->
      <!--<input v-model.tirm="userData.phone" placeholder="Mobile Nummer"/>-->
      <!--<span v-if="$v.userData.phone.$error" class="form-error">Mobile Nummer ist erforderlich</span>-->
      <!--</div>-->
      <div class="fc-form-row">
        <input v-model.tirm="userData.postCode" placeholder="Postleitzahl*"/>
        <span v-if="$v.userData.postCode.$error" class="form-error">Ein gültiger Postleitzahl ist erforderlich</span>
      </div>
      <div class="fc-form-row">
        <input v-model.tirm="userData.city" placeholder="Stadt*"/>
        <span v-if="$v.userData.city.$error" class="form-error">Eine Stadt ist erforderlich</span>
      </div>
<!--      <div class="fc-form-row">-->
<!--        <div>-->
<!--          <input type="checkbox" v-model="userData.agree" id="agree" name="agree"/>-->
<!--          <label for="agree">Hiermit erkläre ich mich einverstanden, während dem ganzen Abend, die Schutzmaske zu tragen.</label>-->
<!--        </div>-->
<!--        <span v-if="$v.userData.agree.$error" class="form-error">Sie müssen bestätigen</span>-->
<!--      </div>-->
<!--      <div class="fc-form-row">-->
<!--        <div>- Beim Konsumieren der Getränke, darf die Schutzmaske für eine kurze Zeit abgenommen werden.</div>-->
<!--        <div>- Bei wiederholter Nichtbeachtung der COVID-19 Regeln, darf der Face Club die Gäste aus dem Club verweisen.</div>-->
<!--        <div>- Schutzmasken können am Eingang bezogen werden.</div>-->
<!--      </div>-->
      <div class="fc-form-row" v-if="serverError">
        <span class="form-error"> {{serverError}}</span>
      </div>
      <button class="fc-button" @click.prevent="registerUser">Registrieren</button>
    </form>
  </div>
</template>

<script>
  import {registerUser} from "../services/graphql";
  import {minLength, required, email, numeric} from "vuelidate/lib/validators";
  import UploadImage from "./UploadImage";

  export default {
    name: "UserRegister",
    components: {UploadImage},
    props: {
      phone: {
        type: String
      }
    },
    data() {
      return {
        serverError: null,
        userData: {
          phone: null,
          firstName: null,
          lastName: null,
          postCode: null,
          city: null
        }
      };
    },
    validations: {
      userData: {
        // phone: {
        //   required,
        // //  minLength: minLength(6)
        // },
        email: {
          required,
          email,
        },
        firstName: {
          required,
          minLength: minLength(2)
        },
        lastName: {
          required,
          minLength: minLength(2)
        },
        postCode: {
          required,
          numeric
        },
        city: {
          required,
        },
        // image: {
        //   required,
        // },
        // agree: {
        //   required,
        //   accepted: val => val === true
        // }
      }
    },

    methods: {
      registerUser() {
        this.$v.userData.$touch();
        if (this.$v.$invalid) {
          return false;
        }

        let clone = Object.assign({}, this.userData);
        delete clone.agree;

        registerUser({
          ...clone,
          postCode: parseInt(clone.postCode)
        })
          .then(() => {
            this.$v.$reset();
            this.userData = {};
            this.$emit("userRegistered")
          })
          .catch(err => {
            if (err.graphQLErrors && err.graphQLErrors[0].message === 'User already exist') {
              this.serverError = 'Benutzer mit dieser E-Mail oder diesem Telefon ist bereits registriert';
            }
          });
      }
    },
    created() {
      this.userData = {
        ...this.userData,
        phone: this.phone
      };
    }
  };
</script>

<style lang="scss">
  @import "UserRegister";
</style>
